export default __webpack_public_path__ + "static/media/B240.344bbb23.png";